module.exports = __webpack_public_path__ + "img/falcon_clan_encampment_small.a5d2bd92.png";